import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { SkillState } from './types';
import { RootState } from '../../types';
import { state } from './state';

const namespaced: boolean = true;

export const skillModule: Module<SkillState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
